import {Component, EventEmitter, Input, Output} from '@angular/core';
import {KENDO_MENUS, MenuSelectEvent} from '@progress/kendo-angular-menu';

import {FonteIconeComponent} from '../fonte-icone/fonte-icone.component';
import {SimpleLibelleComponent} from '../simple-libelle/simple-libelle.component';
import {LibelleDicoPipe} from '../Utilitaires/libelle-dico.pipe';
import {DonneesMenuItem} from './DonneesBarreMenus';

//Composant barre de menus
@Component (
{
  selector: 'val-barre-menus',
  imports: 
  [
    KENDO_MENUS,
    FonteIconeComponent,
    SimpleLibelleComponent,
    LibelleDicoPipe
  ],
  templateUrl: './barre-menus.component.html',
  styleUrl: './barre-menus.component.scss'
})
export class BarreMenusComponent 
{
  //Création
  constructor () 
  {
    this.menuItems = [];

    this.menuClick = new EventEmitter<DonneesMenuItem> ();
  }

  //Menu items
  @Input ()
  public menuItems: DonneesMenuItem[];

  //Evénement click sur un menu
  @Output ()
  public menuClick: EventEmitter<DonneesMenuItem>;

  //Exécute les actions sur un click sur un menu item
  //  Paramètres
  //    event : Données de l’événement
  public ExecuterActionSurClickMenu (event: MenuSelectEvent) : void 
  {
    this.menuClick.emit (event.item);

    if (event.item.action)
      event.item.action (event.item);
  }
}
